import styled from "styled-components";
import { formLabelStyles } from "../../../constants/Styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${formLabelStyles};
`;
